module.exports = __webpack_public_path__ + "static/PrimitiveEight-d3f3c0ea8cfea8060d751584dab547cd.png";